import { render, staticRenderFns } from "./v-payment-card.vue?vue&type=template&id=0e409566&"
import script from "./v-payment-card.vue?vue&type=script&lang=js&"
export * from "./v-payment-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports